import { IAutoMapper } from "../interfaces";

export const mapPendTimelineItems = (automapper: IAutoMapper): void => {
  automapper
    .createMap("default", "PendTimelineItem")
    .forMember("specificDay", o => o.specificDay)
    .forMember("timelineGroup", o => o.timelineGroup);
};
